var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"rounded-full transition-shadow duration-300 hover:elevation-1 hover:transition-shadow hover:duration-300 bg-white"},[_c('img',{class:{
      'object-cover rounded-full': true,
      'border-2 border-solid border-outline': _vm.withBorder && _vm.size !== 'extra-small',
      'border border-solid border-outline': _vm.withBorder && _vm.size === 'extra-small',
      'min-w-[32px] w-[32px] min-h-[32px] h-[32px]': _vm.size === 'extra-small',
      'min-w-[40px] w-[40px] min-h-[40px] h-[40px]': _vm.size === 'small',
      'min-w-[80px] w-[80px] min-h-[80px] h-[80px]': _vm.size === 'medium',
      'min-w-[160px] w-[160px] min-h-[160px] h-[160px]': _vm.size === 'large',
      'w-full h-auto': _vm.size === 'auto',
    },attrs:{"src":_vm.src ? _vm.src : '/images/profile-placeholder.jpg',"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }